import SupplierModel from '../../models/Inventory/InventorySupplierModel';
import BaseStore from '../BaseStore';

class SupplierStore extends BaseStore {
  constructor(transportLayer) {
    super(SupplierModel, transportLayer);
  }
}

export default SupplierStore;



// WEBPACK FOOTER //
// ./src/stores/Inventory/InventorySupplierStore.js